import {
  PLANT_VARIETY_PREFERENCE_ID,
  PLANT_VARIETY_TARGET,
  readPlants,
} from "./biond-global-helper";

export class BiondMealGlobalInterface {
  constructor(isQuiz) {
    this.container = document.querySelector(".meal-selection-section");
    this.selectedMealsCount = this.container?.querySelector('#selected-meals-count');
    this.selectedMealsList = this.container?.querySelector('#selected-meals-list');
    this.selectedExtrasList = this.container?.querySelector('#selected-extras-list');
    this.mainActionButton = this.container?.querySelector('#main-action-button');
    this.mealSelectionWrap = this.container?.querySelector('.meal-selection-wrap'); 
    this.selectedMeals = [];
    this.selectedExtras = [];
    this.selectedSpecials = [];
    this.totalMealsCount = 5; 
    this.activeMealCount = 0;
    this.isQuiz = isQuiz;
    this.mealTypeIds = [];
    this.sideDishIds = [];
    this.preferenceIds = [];
    this.activeMealPrice = 0;
    this.activeMealPriceValue = 0;
    this.activeBoxProductId = 0;
    this.activeBoxVariantId = 0;
    this.selectedSellingPlanId = 0;
    this.boxSizeTitle = "";
    const urlParams = new URLSearchParams(window.location.search);
    const hasChallenge = urlParams.has("challenge");
    this.isChallenge = hasChallenge ? true : false;
    if(this.isChallenge){
      document.querySelector('.selling_plan_once_wrap').remove();
      document.querySelector('.challenge-wrap').classList.add('active');
      
    }
  }
  async getProducts(renderBox = true) {
    this.mealSelectionWrap.classList.add('is-loading');
    const params = new URLSearchParams();

    /*this.mealTypeIds.forEach(id => {
      
    });*/
    this.mealTypeIds.forEach(id => {
      params.append('filter.p.m.custom.meal_types', `gid://shopify/Metaobject/${id}`);
    });
    this.sideDishIds.forEach(id => {
      params.append('filter.p.m.custom.side_dishs', `gid://shopify/Metaobject/${id}`);
    });
    // "Pflanzenvielfalt" ist eine Steuer-Präferenz, kein Produktfilter.
    // Sie bleibt in preferenceIds (für URL, Anzeige und Abo-Speicherung),
    // wird aber nie an Shopify durchgereicht.
    this.getFilterPreferenceIds().forEach(id => {
      params.append('filter.p.m.custom.preferences', `gid://shopify/Metaobject/${id}`);
    });
    //params.append('filter.p.m.custom.meal_types', `gid://shopify/Metaobject/${this.selectedMealType}`);
    //params.append('filter.p.m.custom.side_dishs', `gid://shopify/Metaobject/${this.selectedSideDish}`);
    params.append("filter.p.status", "ACTIVE"); 
    params.append("filter.p.available", "true");
    params.append("filter.p.inventory_quantity", ">0");
    
    
    /*
    this.sideDishIds.forEach(id => {
      
    });*/


    const url = `${this.getCollectionUrl()}?${params.toString()}`;
    console.log('🔗 Filter-URL:', url);

    try {
        const res = await fetch(url);
        const html = await res.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const grid = doc.querySelector('#product-grid');

        if (!grid) {
          console.warn('❌ Kein #product-grid gefunden.');
          return;
        }

        // Logik für Special-Filterung
        if (!this.isQuiz) {
          // Finde alle Elemente mit data-special="true" innerhalb des geladenen Grids
          const specialProducts = grid.querySelectorAll('[data-special="true"]');
          
          // Entferne diese Elemente aus dem temporären DOM-Baum
          specialProducts.forEach(el => el.remove());
          
          console.log(`🚫 ${specialProducts.length} Special-Artikel entfernt (da kein Quiz).`);
        }

        const content = grid.innerHTML;
        const mealGrid = document.querySelector('#meal-grid');
        
        if (mealGrid) {
          mealGrid.innerHTML = "";
          mealGrid.insertAdjacentHTML('beforeend', content);
        }

        setTimeout(() => {
          this.mealSelectionWrap.classList.remove('is-loading');
        }, 600);

      } catch (err) {
        console.error('❌ Fehler beim Laden der Collection-Seite:', err);
      }
  }
  async getExtras() {
    this.mealSelectionWrap.classList.add('is-loading');
    const params = new URLSearchParams();

    params.append("filter.p.status", "ACTIVE"); 
    params.append("filter.p.available", "true");
    params.append("filter.p.inventory_quantity", ">0");

    
    /*
    this.sideDishIds.forEach(id => {
      
    });*/


    const url = `/collections/extras?${params.toString()}`;

    try {
  
      const res = await fetch(url);
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const grid = doc.querySelector('#product-grid');

      if (!grid) {
        console.warn('❌ Kein #product-grid gefunden.');
        return;
      }

      const content = grid.innerHTML;
      const mealGrid = document.querySelector('#extra-grid');
      mealGrid.innerHTML = "";
      mealGrid.insertAdjacentHTML('beforeend', content);
      /*if(renderBox){
        this.renderBoxInfo();
      }*/
      setTimeout(() => {
        this.mealSelectionWrap.classList.remove('is-loading');
      }, 600);
      
    } catch (err) {
      console.error('❌ Fehler beim Laden der Collection-Seite:', err);
    }
  }
  getCollectionUrl() {
    const sideDishId = this.sideDishIds?.[0];

    const collectionMap = {
      '323219718519': '/collections/mahlzeiten-mit-beilage',
      '323219816823': '/collections/mahlzeiten-ohne-beilage'
    };

    const url = collectionMap[sideDishId];

    if (!url) {
      console.warn(`❌ Unbekannter Side Dish (${sideDishId}) – Standard-Collection wird verwendet.`);
      return null;
    }

    return url;
  }
  async getMetaobjectNamesByIds(idGroups) {
    const entries = Object.entries(idGroups).flatMap(([groupKey, ids]) =>
      ids.map(id => ({ groupKey, id }))
    );

    if (entries.length === 0) {
      console.warn('⚠️ Keine IDs übergeben – Abbruch.');
      return {
        meal_types: [],
        preferences: [],
        side_dishs: []
      };
    }

    const query = `
      query GetMetaobjects {
        ${entries.map(({ groupKey, id }) => `
          ${groupKey}_${id}: node(id: "gid://shopify/Metaobject/${id}") {
            ... on Metaobject {
              fields {
                key
                value
              }
            }
          }
        `).join('')}
      }
    `;

    try {
      const response = await fetch('https://jw9wdd-tu.myshopify.com/api/2024-07/graphql', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '22d24b254e1f56c5770f0671863f6a97',
        },
        body: JSON.stringify({ query })
      });

      const result = await response.json();

      const nameMap = {
        meal_types: [],
        preferences: [],
        side_dishs: []
      };

      entries.forEach(({ groupKey, id }) => {
        const key = `${groupKey}_${id}`;
        const obj = result?.data?.[key];
        const nameField = obj?.fields?.find(f => f.key === 'name');
        if (nameField) {
          nameMap[groupKey].push(nameField.value);
        } else {
          console.warn(`⚠️ Kein Name-Feld für ${key} gefunden.`);
        }
      });

      return nameMap;
    } catch (error) {
      console.error('❌ Fehler beim Abrufen der Metaobject-Namen:', error);
      return {
        meal_types: [],
        preferences: [],
        side_dishs: []
      };
    }
  }
  /**
   * Präferenz-IDs ohne die Steuer-Präferenz "Pflanzenvielfalt".
   */
  getFilterPreferenceIds() {
    if (!PLANT_VARIETY_PREFERENCE_ID) return this.preferenceIds;
    return this.preferenceIds.filter((id) => String(id) !== PLANT_VARIETY_PREFERENCE_ID);
  }

  /**
   * Ist "Pflanzenvielfalt" aktiv?
   */
  isPlantVarietyActive() {
    if (!PLANT_VARIETY_PREFERENCE_ID) return false;
    return this.preferenceIds.some((id) => String(id) === PLANT_VARIETY_PREFERENCE_ID);
  }

  /**
   * Alle verschiedenen Pflanzen, die aktuell in der Box liegen.
   */
  getSelectedPlants() {
    const set = new Set();
    this.selectedMeals.forEach((meal) => {
      (meal.plants || []).forEach((p) => set.add(p));
    });
    return set;
  }

  /**
   * Pflanzenzähler im Drawer. Wird nur bei aktiver Präferenz eingeblendet.
   */
  renderPlantCounter() {
    const wrap = document.getElementById("plant-counter");
    if (!wrap) return;

    if (!this.isPlantVarietyActive()) {
      wrap.hidden = true;
      return;
    }

    const plants = this.getSelectedPlants();
    wrap.hidden = false;
    wrap.classList.toggle("is-complete", plants.size >= PLANT_VARIETY_TARGET);
    const value = document.getElementById("plant-count");
    if (value) value.textContent = plants.size;

    const list = document.getElementById("plant-counter-popup-list");
    if (list) {
      const sorted = [...plants].sort((a, b) => a.localeCompare(b, "de"));
      list.textContent = sorted.length > 0 ? sorted.join(", ") : "Noch keine Pflanzen ausgewählt.";
    }
  }

  /**
     * Update meal counter display
     */
    updateMealCounter() {
        if (!this.selectedMealsCount) return;
        const totalQuantity = this.selectedMeals.reduce((total, m) => total + (m.quantity || 1), 0);
        this.selectedMealsCount.textContent = totalQuantity;
    }

    /**
     * Update main action button state
     */
    updateSaveButton() {
        if (!this.mainActionButton) return;
        const totalQuantity = this.selectedMeals.reduce((total, m) => total + (m.quantity || 1), 0);
        const remaining = this.totalMealsCount - this.activeMealCount;

        // Button is never disabled - always allows filling/saving
        
        
        if (totalQuantity === 0 && this.isQuiz) {
            document.querySelector('.meal-selection-actions').classList.remove('has-products');
            document.querySelector('#selected-meals-list').innerHTML = '<p class="empty-items-text">Wähle deine leckeren Mahlzeiten aus.</p>'; 
        } else if (totalQuantity < this.totalMealsCount) {
            // Some meals selected but not enough - show add remaining button
            this.mainActionButton.textContent = this.getTranslations().add_remaining.replace('{count}', remaining);
            this.mainActionButton.disabled = true;
            document.querySelector('.meal-selection-actions').classList.add('has-products');
        } else {
            // All meals selected or over-filled - show save button
            document.querySelector('.meal-selection-actions').classList.add('has-products');
            if(this.isQuiz){
              this.mainActionButton.textContent = "ZUR KASSE";
            }else{
               this.mainActionButton.textContent = this.getTranslations().save_selection;
            }
            this.mainActionButton.disabled = false;
        }
    }

    renderSelectedMeals() {

        if (!this.selectedMealsList) {
            console.warn('⚠️ #selected-meals-list not found, cannot render selected meals');
            return;
        }
        
        /*if (this.selectedMeals.length === 0) {
            this.selectedMealsList.innerHTML = '<p class="no-meals">No meals selected yet.</p>';
            return;
        }*/
        
          this.selectedMealsList.innerHTML = this.selectedMeals.map(meal => this.renderMealHtml(meal, 'box-item-meal')).join('');
        if(this.isQuiz){  
          if(this.selectedExtras.length > 0){
            const hasOnlySpecialExtras = this.selectedExtras.every(extra => extra.isSpecial);
            if(!hasOnlySpecialExtras){
              document.querySelector('.meal-selection-wrap').classList.add('has-extras');
            }else{
              document.querySelector('.meal-selection-wrap').classList.remove('has-extras');
              document.querySelector('.meal-selection-wrap').classList.add('has-only-special-extras');
            }
            this.selectedExtrasList.innerHTML = this.selectedExtras.filter(meal => !meal.isSpecial).map(meal => this.renderMealHtml(meal, 'box-item-extra')).join('');
          }else{
            this.selectedExtrasList.innerHTML = "";
            document.querySelector('.meal-selection-wrap').classList.remove('has-extras');
            document.querySelector('.meal-selection-wrap').classList.remove('has-only-special-extras');
          }
        }
        this.renderPlantCounter();
    }
    renderMealHtml(meal, mealClass) {
        // Surcharge Badge berechnen, falls es ein Special ist
        const surchargeHtml = meal.isSpecial 
            ? `<div class="special-surcharge-small">+ ${(meal.surchargePriceValue * (meal.quantity || 1)).toFixed(2).replace('.', ',')}€</div>` 
            : '';

        return `
        <div class="box-item ${mealClass}" data-collection="main" data-meal-id="${meal.variantId}">
            ${surchargeHtml}
            <img 
                src="${meal.image}" 
                alt="${meal.title}" 
                loading="lazy"
                width="80"
                height="80"
            >
            <div class="wrap-content">
                <p class="title">${meal.title}</p>
                <ul class="icon-list">
                    ${meal.dietaryIcons.map(icon => 
                    `<li><img src="${icon.src}" alt="${icon.alt}" title="${icon.alt}" srcset="${icon.src} 32w" width="32" height="32"></li>`
                    ).join('')}
                </ul>
                <ul class="product-info-list">
                    <li>${meal.calories || '0'} kcal</li>
                    <li>${meal.protein || '0'}g Protein</li>
                    <li>${meal.carbs || '0'}g KH</li>
                    <li>${meal.fat || '0'}g Fett</li>
                </ul>
            </div>
            <div class="wrap-quantity" data-target="change-quantity">
                <button type="button" class="minus-button" data-meal-id="${meal.variantId}">-</button>
                <input type="text" class="current-quantity" data-collection="main" data-id="${meal.variantId}" data-product-id="${meal.id}" value="${meal.quantity || 1}" readonly>
                <button type="button" class="plus-button" data-meal-id="${meal.variantId}">+</button>
            </div>
        </div>
        `;
    }
    addExtra(mealId, quantity = 1){
        const productElement = this.container?.querySelector(`.product-item[data-variant="${mealId}"]`);
        if (!productElement) return;
        
        const mealData = this.extractMealDataFromElement(productElement);
        const mealTotal = this.selectedExtras.reduce((total, m) => total + Number(m.quantity || 1), 0);
        const existingMeal = this.selectedExtras.find(m => m.variantId === mealId);

        if (existingMeal) {
            existingMeal.quantity = (existingMeal.quantity || 1) + quantity;
        } else {
            this.selectedExtras.push({ ...mealData, quantity });
        }

        // Nach dem Hinzufügen reale Menge synchronisieren (falls irgendwo abweicht)
        const realTotal = this.selectedExtras.reduce((total, m) => total + (m.quantity || 1), 0);
        this.container.classList.remove('show-buy-step');
        this.updateMealCounter();
        
        this.renderSelectedMeals();
        this.renderBoxInfos();
        this.updateSaveButton();
        console.log(this.selectedExtras);
    }
    removeExtra(mealId) {
        
        const index = this.selectedExtras.findIndex(m => m.variantId === mealId);
        
        if (index > -1) {
            const meal = this.selectedExtras[index];

            if (meal.quantity && meal.quantity > 1) {
                meal.quantity--;
            } else {
                this.selectedExtras.splice(index, 1);
            }
            this.updateMealCounter();
            this.renderSelectedMeals();
            this.renderBoxInfos();  
            this.updateSaveButton();     
        }
    }
    addMeal(mealId, quantity = 1, updateUrl = true, isExtra = false) {
        /*
        const mealData = null;
        const existingMeal = this.biondMealGlobalInterface.selectedMeals.find(m => m.variantId === mealId);
        if (existingMeal) {
          mealData = this.extractMealDataFromElement(productElement);
        }else{
          const productElement = this.container?.querySelector(`.product-item[data-variant="${mealId}"]`);
          if (!productElement) return;
          mealData = this.extractMealDataFromElement(productElement);
        }*/
        const productElement = this.container?.querySelector(`.product-item[data-variant="${mealId}"]`);
       
        if (!productElement) return;
        
        const mealData = this.extractMealDataFromElement(productElement);
        console.log(mealData)
        // aktuelle Gesamtanzahl vor dem Hinzufügen
        const mealTotal = this.selectedMeals.reduce((total, m) => total + Number(m.quantity || 1), 0);
        const existingMeal = this.selectedMeals.find(m => m.variantId === mealId);

        // Prospektiv: wie viele wären es nach diesem Klick?
        const prospectiveCount = mealTotal + quantity;

        // Prospektivwert setzen (Plus/Minus soll darauf basieren)
        this.activeMealCount = prospectiveCount;

        if (this.isQuiz) {
            
            // Ziel anhand Prospektivwert anpassen
            this.checkAndUpdateBoxSize();
            this.renderBoxInfos();
            // Kapazität NACH Zielanpassung prüfen
            const boxLimit = Number(this.totalMealsCount);
            
            if (prospectiveCount > boxLimit) {
              showAlert(`Box ist voll. Du kannst nur ${boxLimit} Mahlzeiten wählen.`, 'error');
              return;
            }

        } else {
            // Standardprüfung wie bisher, aber mit Prospektivwert
            const boxLimit = Number(this.totalMealsCount);
            if (mealTotal >= boxLimit) {
            showAlert(`Box ist voll. Du kannst nur ${boxLimit} Mahlzeiten wählen.`, 'error');
            return;
            }
        }
       
        // Jetzt wirklich hinzufügen
        if (existingMeal) {
            existingMeal.quantity = (existingMeal.quantity || 1) + quantity;
        } else {
            this.selectedMeals.push({ ...mealData, quantity });
        }

        // Nach dem Hinzufügen reale Menge synchronisieren (falls irgendwo abweicht)
        const realTotal = this.selectedMeals.reduce((total, m) => total + (m.quantity || 1), 0);
        this.activeMealCount = realTotal;

        this.updateMealCounter();
        this.renderSelectedMeals();
        this.updateSaveButton();
        if (this.isQuiz && updateUrl) {
          this.updateUrl();
        }
        if(this.isQuiz){
          const isSpecial = productElement?.dataset.special === "true";
          if(isSpecial){
              const variantId = productElement.dataset.variantId;
              const surchargeId = productElement.dataset.surchargeId;
              const surchargePriceValue = productElement.dataset.surchargePriceValue;
              const surchargePrice = productElement.dataset.surchargePrice;
              this.addSpecial(mealId, surchargeId, surchargePriceValue, surchargePrice, quantity);
          }
        }
    }
    addSpecial(mealId, surchargeId, surchargePriceValue, surchargePrice, quantity = 1){
        console.log(surchargeId);
        
        
        const boxItem = document.querySelector(`.box-item-meal[data-meal-id="${mealId}"]`);
        
        //boxItem.classList.add('is-special');
        boxItem.dataset.special = "true";
        boxItem.dataset.surchargeId = surchargeId;
        boxItem.dataset.surchargePriceValue = surchargePriceValue;
        /*this.selectedSpecials.push({
            variantId: surchargeId,
            quantity: 1,
            price: surchargePriceValue
        });*/
        const existingMeal = this.selectedExtras.find(m => m.variantId === surchargeId);

        if (existingMeal) {
            existingMeal.quantity = (existingMeal.quantity || 1) + quantity;
        } else {
            this.selectedExtras.push({
              variantId: surchargeId,
              quantity: quantity,
              price: surchargePriceValue,
              isSpecial: true
          });
        }
        console.log(this.selectedExtras)
        this.updateMealCounter();
        this.renderSelectedMeals();
        this.renderBoxInfos();
        this.updateSaveButton();
    }
    removeSpecial(surchargeId){
      const index = this.selectedExtras.findIndex(m => m.variantId === surchargeId);
      if (index > -1) {
          const meal = this.selectedExtras[index];

          if (meal.quantity && meal.quantity > 1) {
              meal.quantity--;
          } else {
              this.selectedExtras.splice(index, 1);
          }
          this.updateMealCounter();
          this.renderSelectedMeals();
          this.renderBoxInfos();  
          this.updateSaveButton();     
      }
    }
    removeMeal(mealId) {

        const index = this.selectedMeals.findIndex(m => m.variantId === mealId);
        
        if (index > -1) {
            const meal = this.selectedMeals[index];

            if (meal.quantity && meal.quantity > 1) {
                meal.quantity--;
            } else {
                this.selectedMeals.splice(index, 1);
            }
            const totalQuantity = this.selectedMeals.reduce((total, m) => total + (m.quantity || 1), 0);
            this.activeMealCount = totalQuantity;
            if (this.isQuiz) {
                this.checkAndUpdateBoxSize(true);
                this.renderBoxInfos();
            }
            this.updateMealCounter();
            
            this.renderSelectedMeals();
            this.updateSaveButton();
            if (this.isQuiz) {
                this.updateUrl();
                if(meal.isSpecial){ 
                  this.removeSpecial(meal.surchargeId);
                }
            }
            console.log('✅ Meal removed:', mealId);
            // >>> Box-Logik auch beim Entfernen prüfen
           
            
        }
    }
    extractMealDataFromElement(productElement) {
        const variantId = productElement.dataset.variant;
        const id = productElement.dataset.id;
        const product_meal_types = productElement.dataset.mealTypes;
        const product_side_dishs = productElement.dataset.sideDishs;
        const product_plants = readPlants(productElement);
        const title = productElement.querySelector('.wrap-content h3')?.textContent?.trim() || '';
        const image = productElement.querySelector('img.product-img')?.getAttribute('src') || '';
        const isSpecial = productElement.dataset.special === "true";
        // Dietary Icons
        const dietaryIcons = Array.from(productElement.querySelectorAll('.icon-list img')).map(img => ({
            src: img.getAttribute('src'),
            alt: img.getAttribute('title') || ''
        }));
        // Nutrition Info
        const infoItems = productElement.querySelectorAll('.product-info-list li');
        const calories = infoItems[0]?.textContent?.replace(/[^0-9,]/g, '') || '0';
        const protein  = infoItems[1]?.textContent?.replace(/[^0-9,]/g, '') || '0';
        const carbs    = infoItems[2]?.textContent?.replace(/[^0-9,]/g, '') || '0';
        const fat      = infoItems[3]?.textContent?.replace(/[^0-9,]/g, '') || '0';
        let price = 0;
        if(productElement.querySelector('.product-price')){
          price = parseFloat(productElement.querySelector('.product-price').textContent.replace("€", "").trim().replace(",", "."))
        }
        
        return {
            id,
            variantId,
            title,
            image,
            dietaryIcons,
            calories,
            protein,
            carbs,
            fat,
            quantity: 1, // Default quantity when first extracting data,
            price: price,
            meal_types: product_meal_types,
            side_dishs: product_side_dishs,
            plants: product_plants,
            isSpecial: isSpecial,
            surchargeId: isSpecial ? productElement.dataset.surchargeId : null,
            surchargePriceValue: isSpecial ? productElement.dataset.surchargePriceValue : null,
        };
    }
    checkAndUpdateBoxSize(isRemoved = false) {
      this.container.classList.remove('show-buy-step'); 
      const activeLis = Array.from(document.querySelectorAll('.quiz_products li.active'));
      const steps = activeLis
        .map(li => parseInt(li.dataset.total, 10))
        .filter(n => !Number.isNaN(n))
        .sort((a, b) => a - b);

      if (steps.length === 0) return;

      const boxCount = Number(this.activeMealCount);      // Prospektivwert
      const current = Number(this.totalMealsCount);       // aktuelles Ziel

      // Perspektivisch: gibt es einen Step > current? Dann kann man nur EINEN Step hochgehen,
      // und zwar nur wenn die Boxmenge das aktuelle Ziel überschreitet.
      const nextHigherThanCurrent = steps.find(t => t > current);
      if (boxCount > current && nextHigherThanCurrent) {
        this.totalMealsCount = parseInt(nextHigherThanCurrent);
      }
      if(isRemoved){
        const nextLowerThanCurrent = steps.find(t => t < current);
        if (boxCount < current && nextLowerThanCurrent) {
          this.totalMealsCount = parseInt(nextLowerThanCurrent);
        }
      }
      // Disable/Enable basierend auf aktueller Boxmenge (nicht dem Ziel!)
      activeLis.forEach(li => {
        const total = parseInt(li.dataset.total, 10);
        const input = li.querySelector('input[type="radio"]');
        const disable = total < boxCount;

        if(total != this.totalMealsCount){
          li.classList.toggle('disabled', disable);
          if (input) input.disabled = disable;
        }
       
      });
      // Aktuellen Ziel-Step markieren und Radio setzen
      const targetLi = activeLis.find(li => parseInt(li.dataset.total, 10) === Number(this.totalMealsCount));
      if (targetLi) {
        activeLis.forEach(li => li.classList.remove('current-item'));
        targetLi.classList.add('current-item');
        const targetRadionInput = targetLi.querySelector('input[type="radio"]');
  

        const radio = targetLi.querySelector('input[type="radio"]');
        if (radio && !radio.checked) {
          if(this.activeBoxProductId != targetRadionInput.value){
            this.activeBoxProductId = targetRadionInput.value;
            this.activeBoxVariantId = targetRadionInput.dataset.variantId;
            this.totalMealsCount = parseInt(targetRadionInput.dataset.total);
            this.activeMealPrice = targetRadionInput.dataset.price;
            this.activeMealPriceValue = targetRadionInput.dataset.priceValue;
            this.activeMealName = targetRadionInput.dataset.name;
            radio.checked = true;
            this.checkAndUpdateBoxSize();
            this.getSellingPlans();
          }
         
          //radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
    renderBoxInfos(){
      const mealTotalCount = this.container.querySelector('#total-meals-count'); 
      const mealPrice = this.container.querySelector('#total-meals-price'); 
      const extrasPrice = this.container.querySelector('#extras-price'); 
      const mealPriceUnit = this.container.querySelector('.meal-price-unit'); 
      const mealUnitSaving = this.container.querySelector('.meal-unit-saving');
      const mealCountWrap = this.container.querySelector('.selected-meals-count-wrap');
      const mealUnitSavingCount = this.container.querySelector('.meal-unit-saving-count'); 
      const mealUnitSavingPrice = this.container.querySelector('.meal-unit-saving-price'); 
      const progressEl = this.container.querySelector('.box-progressbar-progress');
      const activeLis = Array.from(document.querySelectorAll('.quiz_products li.active'));
      let steps = null;
      let totalPriceCents = 0;
      let unitPriceCents = 0;
      let unitPriceEuro = 0;

      if(this.isQuiz){

      // Verhältnis berechnen
          let percent = (this.activeMealCount / this.totalMealsCount) * 100;
          // Begrenzen auf 100 %
          if (percent > 100) percent = 100;
          // Breite setzen
          progressEl.style.width = `${percent}%`;

          mealTotalCount.textContent = this.totalMealsCount;
          mealPrice.textContent = this.activeMealPrice;
          totalPriceCents = Number(this.activeMealPriceValue);
          unitPriceCents = totalPriceCents / this.totalMealsCount;

          // Umrechnung in Euro
          unitPriceEuro = unitPriceCents / 100;

          // Formatierung als Währung (de-DE → Komma statt Punkt)
          mealPriceUnit.textContent = unitPriceEuro.toLocaleString('de-DE', {
            style: 'currency',
            currency: 'EUR'
          });
          
          steps = activeLis.map(li => parseInt(li.dataset.total, 10)).filter(n => !Number.isNaN(n)).sort((a, b) => a - b);
          mealUnitSaving.classList.remove('is-active');
          mealCountWrap.classList.remove('box-full');
      }else{
        const boxSizeNumber = this.container.querySelector('#box-size-number'); 
        const boxSizeTitleElement = this.container.querySelector('#box-size-title'); 
        const mealTypePreference = this.container.querySelector('#meal-type-preference'); 
        const dietaryPreference = this.container.querySelector('.preference-category .selected-filter-quiz'); 
        const dietaryFilterCheckboxes = this.container.querySelectorAll('.preference-category input[type="checkbox"]');
        const sideDishPreference = this.container.querySelector('#side-dish-preference'); 

        mealTotalCount.textContent = this.totalMealsCount;
        boxSizeNumber.textContent = this.totalMealsCount;
        boxSizeTitleElement.textContent = this.boxSizeTitle;

        if (Array.isArray(this.preferenceIds)) {
          dietaryFilterCheckboxes.forEach(checkbox => {
            if (this.preferenceIds.includes(checkbox.value)) {
              checkbox.checked = true;
            }
          });
        }

        this.getMetaobjectNamesByIds({
          meal_types: this.mealTypeIds,
          preferences: this.preferenceIds,
          side_dishs: this.sideDishIds
        }).then(nameMap => {
          mealTypePreference.textContent = nameMap.meal_types.join(', ') || '–';
          dietaryPreference.textContent = nameMap.preferences.join(', ') || 'Präferenzen';
          sideDishPreference.textContent = nameMap.side_dishs.join(', ') || '–';
        });


      }
      if (this.totalMealsCount == this.activeMealCount && this.isQuiz) {
        // nächstgrößeren Step finden
        const nextStep = steps.find(step => step > this.activeMealCount);
        mealCountWrap.classList.add('box-full');
        if (nextStep) {
          mealUnitSaving.classList.add('is-active');
          
          // wie viele Mahlzeiten fehlen bis zum nächsten Step
          const missingMeals = nextStep - this.activeMealCount;
          mealUnitSavingCount.textContent = missingMeals;

          // nächstes <li> Element holen
          const nextLi = document.querySelector(`.quiz_products li.active[data-total="${nextStep}"]`);
          if (nextLi) {
            const nextPriceCents = Number(nextLi.querySelector('input').dataset.priceValue);

            // nächster Preis pro Mahlzeit
            const nextUnitPriceCents = nextPriceCents / nextStep;
            const nextUnitPriceEuro = nextUnitPriceCents / 100;

            // Ersparnis pro Mahlzeit = aktueller Preis - nächster Preis
            const savingPerMeal = unitPriceEuro - nextUnitPriceEuro;

            // nur anzeigen, wenn positiv
            if (savingPerMeal > 0) {
              mealUnitSavingPrice.textContent = savingPerMeal.toLocaleString('de-DE', {
                style: 'currency',
                currency: 'EUR'
              });
            } else {
              mealUnitSavingPrice.textContent = '';
            }
          }
        } else {
          // kein nächster Step mehr vorhanden
          mealUnitSavingCount.textContent = '';
          mealUnitSavingPrice.textContent = '';
        }
      }
      
      if(this.selectedExtras.length > 0){
          // Angenommen this.selectedExtras ist dein Array
          const extras = this.selectedExtras;

          // Summe berechnen: Preis * Menge
          const total = extras.reduce((sum, item) => {
            return sum + item.price * item.quantity;
          }, 0);

          // Formatieren als Euro-Preis (de-DE Format)
          const formatted = new Intl.NumberFormat("de-DE", {
            style: "currency",
            currency: "EUR"
          }).format(total);

          // In das Element mit der ID extras-price schreiben
          document.getElementById("extras-price").textContent = formatted;

      }
      
      this.renderPlantCounter();
    }
    async getSellingPlans() {
      const query = `
        query {
          product(id: "gid://shopify/Product/${this.activeBoxProductId}") {
            title
            sellingPlanGroups(first: 20) {
              edges {
                node {
                  name
                  sellingPlans(first: 20) {
                    edges {
                      node {
                        id
                        name
                        billingPolicy {
                          ... on SellingPlanRecurringBillingPolicy {
                            interval
                            intervalCount
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `;
      try {
        const response = await fetch("https://jw9wdd-tu.myshopify.com/api/2025-01/graphql", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": "22d24b254e1f56c5770f0671863f6a97",
          },
          body: JSON.stringify({ query }),
        });

        const result = await response.json();

        const groups = result.data?.product?.sellingPlanGroups?.edges || [];
        const ul = document.querySelector(".selling-plan-selection .options");
        ul.innerHTML = ""; // alte Einträge löschen

        // Zeitlogik
        const now = new Date();
        const day = now.getDay(); // 0=Sonntag, 1=Montag, ..., 6=Samstag
        const hour = now.getHours();
        const minute = now.getMinutes();

        const showWithDot =
          (day === 2) || // Dienstag
          (day === 3) || // Mittwoch
          (day === 4 && hour < 9); // Donnerstag vor 9:00

        groups.forEach(group => {
            const plans = group.node.sellingPlans.edges;
            plans.forEach(plan => {
              const node = plan.node;
              const hasDot = node.name.trim().endsWith(".");

              // Name ohne Punkt am Ende
              const sellingPlanName = node.name.replace(/\.$/, "");
              console.log(sellingPlanName)
              // Wenn Challenge aktiv ist, nur "Abo (wöchentlich)" zulassen
              if (this.isChallenge) {
                if (sellingPlanName !== "Abo (wöchentlich)") {
                  return; // alle anderen überspringen
                }
              }

              // Filter nach Zeit und Punkt
              if ((showWithDot && hasDot) || (!showWithDot && !hasDot)) {
                const li = document.createElement("li");
                li.dataset.sellingPlan = node.id;
                li.textContent = sellingPlanName;
                const isFirst = ul.children.length === 0;
        
                ul.appendChild(li);
                if (isFirst) { 
                  li.classList.add("active"); 
                  li.click(); 
                  document.getElementById("subscription").checked = false;
                }
              }
            });
        });

      } catch (error) {
        console.error("❌ Fehler beim Abrufen der Selling Plans", error);
      }
    }
  
  
    updateUrl() {
      const params = new URLSearchParams(window.location.search);

      if (this.mealTypeIds.length > 0) {
        params.set('meal_types', this.mealTypeIds[0]);
      }
      if (this.sideDishIds.length > 0) {
        params.set('side_dishs', this.sideDishIds[0]);
      }

      if (this.preferenceIds.length > 0) {
        params.set('preferences', this.preferenceIds.join(','));
      }else {
        params.delete('preferences');
      }
      // Alle Produkte einsammeln
      const productStrings = [];

      this.selectedMeals.forEach(selectedMeal => {
        productStrings.push(`${selectedMeal.variantId}:${selectedMeal.quantity}`);
      });

      if (productStrings.length > 0) {
        params.set('products', productStrings.join(','));
      }else {
        params.delete('products');
      }
      /*if(this.biondQuizInterface.selectedMealType != null && this.biondQuizInterface.selectedSideDish != null){ 
        this.biondQuizInterface.getProducts();
        const radio = document.querySelector('.quiz_products li.active[data-total="5"] input[type="radio"]');
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event("change", { bubbles: true }));
        }
        //this.biondQuizInterface.renderSelectedBox();
      }*/
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState({}, '', newUrl);
    }
    getTranslations() {
        // Try to get translations from a global object or use fallbacks
        if (window.mealSelectionTranslations) {
        return window.mealSelectionTranslations;
        }
        
        // Fallback translations
        return {
        no_order_title: 'Keine Bestellung gefunden',
        no_order_message: 'Wir konnten keine Bestellung finden, um Ihre Mahlzeitenpräferenzen zu laden.',
        view_orders: 'Meine Bestellungen anzeigen',
        take_quiz: 'Quiz erneut durchführen',
        go_home: 'Zur Startseite',
        fill_automatically: 'AUTOMATISCH FÜLLEN',
        add_remaining: 'Noch {count} hinzufügen',
        save_selection: 'SPEICHERN',
        // Order selection table translations
        order_selection_title: 'Wählen Sie eine Bestellung',
        order_selection_message: 'Die angeforderte Bestellung wurde nicht gefunden. Bitte wählen Sie eine Ihrer Bestellungen aus:',
        order_table_header_id: 'Bestellnummer',
        order_table_header_date: 'Datum',
        order_table_header_preferences: 'Präferenzen',
        order_table_header_status: 'Status',
        order_table_header_action: 'Aktion',
        order_table_button_select: 'Auswählen',
        order_table_no_orders: 'Keine Bestellungen',
        order_table_no_orders_message: 'Sie haben noch keine Bestellungen. Starten Sie mit einem Quiz, um Ihre Präferenzen zu definieren.',
        // Status translations
        status_unfulfilled: 'Nicht ausgeführt',
        status_partial: 'Teilweise ausgeführt',
        status_fulfilled: 'Ausgeführt',
        status_restocked: 'Nachbestellt',
        status_not_eligible: 'Nicht berechtigt'
        };
    }
}
